<template>
  <VContent>
    <VContainer fill-height>
      <VLayout
              style="{max-width:500px;}"
              align-content-center
              mx-auto
              wrap>
        <VFlex xs12 sm8 offset-sm2 md5 offset-md4>
          <BaseCard>
      <VCardTitle class="title font-weight-light">
        Reset password
      </VCardTitle>
            <VContainer v-if="!reseting">
              <VFlex xs12>
                <p class="subtitle-1 font-weight-light" >
                  Enter the email of phone associated with the account
                </p>
              </VFlex>
              <VFlex xs12>
                <UserName />
                <VLayout align-center>
                  <VFlex xs8>

                  </VFlex>
                  <VFlex text-xs-right>
                    <BaseBtn
                            :disabled="!$store.state.username"
                            class="ma-0"
                            @click="requestReset()"
                            :loading="loading"
                    >
                      Reset
                    </BaseBtn>
                  </VFlex>
                </VLayout>
              </VFlex>
            </VContainer>
            <VContainer v-else>
              <VFlex xs12>
                Please check your email
              </VFlex>
            </VContainer>

            <VCardActions>
              <v-btn  text
                      class="ma-0"
                      @click="step=1"
                      to="/auth/entercode"
              >
                Have Code?
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn  text
                    class="ma-0"
                    @click="step=1"
                    to="/auth/signin"
              >
                Sign In
              </v-btn>
            </VCardActions>

          </BaseCard>
        </VFlex>
      </VLayout>
    </VContainer>
  </VContent>
</template>

<script>

    import BaseBtn from "../../components/BaseBtn";
    import {
      mapActions,
      mapMutations
    } from 'vuex'
    import UserName from "./UserName";

    export default {
      components: {UserName, BaseBtn},
      data: () => ({
        username: undefined,
        verificationCode: undefined,
        newPassword: undefined,
        loading: false,
        reseting: false,
        show: false
      }),
      name: 'Recover',
        mounted(){

        },
        methods: {
          ...mapActions('cognito', ['registerUser','forgotPassword']),
          ...mapActions(['openPost']),
          ...mapMutations(['setSnackbar']),
          async requestReset(){
            this.loading=true
            let data = {
              app: this.$store.state.app,
              identitypool: this.$store.state.idpool,
              clientid: this.$store.state.client,
              username:this.$store.state.username //not mapping state here
            }
            let res = await this.openPost({body:data,path:'api/auth/requestresetv2'})
            if(res.error){
              this.loading=false;
              return
            }
            this.$store.commit('setSnackbar',{
              type: 'info',
              msg: res.message,
              timeout:6000
            })
            if(res.CodeDeliveryDetails.DeliveryMedium==='SMS'){
              this.$router.push('/auth/entercode')
            } else if (res.CodeDeliveryDetails.DeliveryMedium==='EMAIL') {
              this.$router.push('/auth/confirm')
            }
            this.loading=false;
          }
        }
    }
    // this.forgotPassword({
    //   username: this.username,
    //   env:'dev'
    // }).then(()=>{
    //       em.loading=false;
    //       em.$store.commit('setSnackbar',{
    //         type: 'info',
    //         msg: 'Check your email for a reset link',
    //         timeout:6000
    //       })
    //       em.reseting = true;
    //     })
</script>

